import * as React from 'react';

import { IBanner } from '../../models/content.interfaces';
import { PhoneNoPhone } from '../PhoneNoPhone/PhoneNoPhone';
import { BannerGraphic } from '../BannerGraphic/BannerGraphic';
import { BannerImage } from '../BannerImage/BannerImage';
import { IVerticalOffset } from '../Container';

export const BannerResponsive = ({ ...props }: IBanner & IVerticalOffset) => {
  return <PhoneNoPhone phone={<BannerGraphic {...props} />} noPhone={<BannerImage {...props} />} />;
};
